import { Group, Stack, Text } from "@mantine/core";
import { ButtonCheckboxV2 } from "./ButtonCheckboxV2";
import type { ButtonToggleProps } from "./ButtonToggle";

export const ButtonToggleV2 = ({
  value,
  onChange,
  align = "center",
  trueLabel,
  falseLabel,
  error,
}: ButtonToggleProps) => {
  return (
    <Stack gap="s1">
      <Group w="100%" gap="s2">
        <ButtonCheckboxV2
          id="true"
          onClick={() => onChange(true)}
          isActive={value ?? false}
          align={align}
          error={error}
        >
          {trueLabel}
        </ButtonCheckboxV2>
        <ButtonCheckboxV2
          id="false"
          onClick={() => onChange(false)}
          isActive={value === false}
          error={error}
          align={align}
        >
          {falseLabel}
        </ButtonCheckboxV2>
      </Group>
      {error && (
        <Text size="sm" c="error">
          {error}
        </Text>
      )}
    </Stack>
  );
};
